import { createSelector, createFeatureSelector } from '@ngrx/store';

import { AppState } from '../shared/models';

export const getAppState = createFeatureSelector<AppState>('app');

export const getNutrientCategories = createSelector(
  getAppState,
  (state: AppState) => state.nutrientCategories,
);
